// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-22JxQRsV fl","tabSwitch":"tabSwitch-3Apcgm2H"};